import type { ComponentProps } from 'react';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { SeasonalityIcon } from '#src/atoms/icons/SeasonalityIcon/index.tsx';
import { useSportContext } from '#src/contexts/sport/index.ts';

type Props = {
  sport?: Sport;
} & Omit<ComponentProps<typeof SeasonalityIcon>, 'sport'>;

export const SportSeasonalityIcon = ({ sport, ...props }: Props) => {
  const { sport: sportContext } = useSportContext();
  return <SeasonalityIcon {...props} sport={sport || sportContext} />;
};
